import { RelatorioAuditoriaItem, RelatorioAuditoriaQueryParams } from "../typings";
import http from "infra/http";
import { PaginateResult } from 'resources/types/shared';
import { useInfiniteQuery } from "react-query";

export function useRelatorioAuditoriaInfiniteScroll(params: RelatorioAuditoriaQueryParams) {
  return useInfiniteQuery(
    ["/v1/relatorios/auditoria", params],
    async ({ pageParam }) => {
      const { data } = await http.get<PaginateResult<RelatorioAuditoriaItem>>(
        "/v1/relatorios/auditoria",
        { params: {
          ...params,
          page: pageParam,
        } }
      );

      return data;
    },
    {
      getNextPageParam: (lastPage) =>
        lastPage.meta.currentPage >= lastPage.meta.totalPages
          ? undefined
          : lastPage.meta.currentPage + 1,
    }
  );
}
